import { RouteConfig } from 'vue-router';
import store from '@/store';
import { LocalStorage } from '@/enums/storage.enum';

export const profileConfigRoute: RouteConfig = {
  path: '/profile',
  component: () => import(/* webpackChunkName: "Profile" */ '@/views/main/settings/Profile.vue'),
  name: 'profileConfig',
  beforeEnter(to, from, next) {
    store.commit('profile/setId', localStorage.getItem(LocalStorage.USER_ID));
    store
      .dispatch('card/list')
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'Nie udało się pobrać profilu.' }));
  }
};
